import { useAppSelector } from '../store/hooks'
import { selectAccountId } from '../store/auth/authSlice'
import { useGetAccountQuery } from '../store/accountUserSettings/accountUserSettings'
import { useMemo } from 'react'
import { stripToText } from './util'

export const useEffectiveConfig = () => {
  const accountId = useAppSelector(selectAccountId)
  const { data: accountResponse, isFetching: accountIsFetching } = useGetAccountQuery({ accountId })

  const effectiveConfig = accountResponse?.data?.effectiveConfig

  const pdfComplianceMessage = useMemo(() => {
    if (effectiveConfig?.complianceConfig?.pdfComplianceMessage?.enabled && effectiveConfig.complianceConfig.pdfComplianceMessage.message) {
      return stripToText(effectiveConfig.complianceConfig.pdfComplianceMessage.message)
    }
    return undefined
  }, [effectiveConfig])

  const emailComplianceMessage = useMemo(() => {
    if (effectiveConfig?.complianceConfig?.emailComplianceMessage?.enabled && effectiveConfig.complianceConfig.emailComplianceMessage.message) {
      return stripToText(effectiveConfig.complianceConfig.emailComplianceMessage.message)
    }
    return undefined
  }, [effectiveConfig])

  return { effectiveConfig, emailComplianceMessage, pdfComplianceMessage, accountIsFetching }
}
